import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { ConcludeActivityDialogComponent } from './conclude-activity-dialog/conclude-activity-dialog.component';
import { NextActivityFormComponent } from './next-activity-form/next-activity-form.component';
import { PostponeActivityDialogComponent } from './postpone-activity-dialog/postpone-activity-dialog.component';
import { ScheduleMomentFieldComponent } from './schedule-moment-field/schedule-moment-field.component';

/**
 * The activity dialogs of E4 (SPEC-2026-10-crm-activities-cadence — RF-17, RF-24), declared ONCE
 * and exported to the tasks area, the board and the attendance panel — the `CardRadarModule`
 * pattern. The two building blocks (the date + time + "sem horário" field and the next-activity
 * form) are exported too: the next-action dialog and the task form render them instead of
 * carrying their own type lists and date inputs.
 */
@NgModule({
  imports: [SharedModule],
  declarations: [
    ScheduleMomentFieldComponent,
    NextActivityFormComponent,
    ConcludeActivityDialogComponent,
    PostponeActivityDialogComponent,
  ],
  exports: [
    ScheduleMomentFieldComponent,
    NextActivityFormComponent,
    ConcludeActivityDialogComponent,
    PostponeActivityDialogComponent,
  ],
})
export class ActivityDialogsModule { }
